import { IMPORTANCE_OPTIONS } from '../types/importanceOptions';
import { STATE_OPTIONS } from '../types/stateOptions';
import JInspectorRow from './JInspectorRow';
import JInspectorFooter from './JInspectorFooter';

/**
 * JInspectorFields — all editable rows + footer for JInspector.
 * @param {object} current - JInspectorState instance with current field values
 * @param {object[]} entryTypes - { label, value }[] for Type dropdown from userTypeEngine
 * @param {object[]} serviceOptions - { label, value }[] for service dropdown from quotaEngine
 * @param {boolean} isDirty
 * @param {Function} onChange - fn(field, value) called on any field change
 * @param {Function} onSave
 * @param {Function} onCancel
 */
export default function JInspectorFields({ current, entryTypes, serviceOptions, isDirty, onChange, onSave, onCancel }) {
    const entryTypeOptions = entryTypes;

    return (
        <>
            <JInspectorRow label="Title" value={current.title} onChange={(v) => onChange('title', v)} text />

            {/* Service — free-text combobox, niet richSelect: je moet een nieuwe, nog niet
                bestaande service kunnen intypen om een entry ernaartoe te verplaatsen. */}
            <JInspectorRow
                label="Service"
                value={current.service}
                options={serviceOptions}
                onChange={(v) => onChange('service', v)}
                editSelect
            />

            <JInspectorRow
                label="Importance"
                value={current.importanceId}
                options={IMPORTANCE_OPTIONS}
                onChange={(v) => onChange('importanceId', v)}
                richSelect
            />
            <JInspectorRow
                label="Prio"
                value={current.prioId}
                options={IMPORTANCE_OPTIONS}
                onChange={(v) => onChange('prioId', v)}
                richSelect
            />
            <JInspectorRow
                label="Cat"
                value={current.cat}
                onChange={(v) => onChange('cat', v)}
                text
                tooltip="This is the category you assigned to this note. You can create a special filter for it so it will show up as a node."
            />

            <JInspectorRow label="Format" value={current.format} onChange={(v) => onChange('format', v)} text />
            <JInspectorRow
                label="Tid"
                value={current.tid}
                onChange={(v) => onChange('tid', v)}
                text
                tooltip="Template ID — the template this data note is linked to"
            />
            {/* ADDED — Journal.Remark, free text note on the entry */}
            <JInspectorRow label="Remark" value={current.remark} onChange={(v) => onChange('remark', v)} textarea onSave={onSave} />
            <JInspectorRow label="Stage" value={current.stage} onChange={(v) => onChange('stage', v)} text />
            <JInspectorRow
                label="State"
                value={current.stateId}
                options={STATE_OPTIONS}
                onChange={(v) => onChange('stateId', v)}
                richSelect
            />

            {/* CHANGED — field renamed type (was entryType), matches JInspectorState/entry naming */}
            <JInspectorRow
                label="Type"
                value={current.type}
                options={entryTypeOptions}
                onChange={(v) => onChange('type', v)}
                richSelect
            />

            {/* CHANGED — field renamed isPinned (was pinned), matches JInspectorState/entry naming */}
            <JInspectorRow label="Pinned" value={current.isPinned} onChange={(v) => onChange('isPinned', v)} checkbox />

            <JInspectorFooter isDirty={isDirty} onSave={onSave} onCancel={onCancel} />
        </>
    );
}
